module.exports = __webpack_public_path__ + "static/media/time_series_covid19_confirmed_global.62b0c51a.csv";